import React, { Fragment, useState, useContext, useEffect } from 'react';
import {
    Paper,
    Grid,
    Link,
    Button,
    Typography,
    Dialog,
    DialogContent,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useStyles } from '../styles/Styles';
import 'date-fns';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';

const SchedulerMain = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const {
        userInfo,
        setUserInfo,
        errors,
        clearErrors,
        loading,
        CheckifSoftLock,
        getApplicationDetails,
        applicationDetails,
        requestForOTP,
        otp_succ,
        otpRequest,
        setIncorrectLinkError
    } = documentUploadContext;

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    const notificationContext = useContext(NotificationContext);
    const handleSubmitClick = (e) => {
        e.preventDefault();

        if (applicationDetails !== null) {
            otpRequest(applicationDetails.mobileNumber);
            setOpen(true);
        }
    };

    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        var currentURL = window.location.href;

        if (currentURL.includes("&")) {
            setIncorrectLinkError();
        }
        else {
            getApplicationDetails(id);
        }
        
        if (errors != null) {
            notificationContext.setNotification(errors, 'error');
        }

    }, [userInfo, errors]);

    return (
        <div>
            <Header page={3} />        
            <div className={classes.banner}>
            {
                loading ? <Spinner /> :
                    <Fragment>
                        {
                            errors != null ? null : <Typography className={classes.paragraph}>Thank you for applying for a PSBank Savings Account through the PSBank Mobile App. In order to complete your application, please schedule a video call with us by selecting your preferred date and time.</Typography>
                        }
                        <Paper elevation={0} className={classes.paper}>
                            {
                                errors != null ? <Alert severity='error' >You have provided an invalid link. Please click on the button below to go back to our website home page. Thank you.</Alert> : null
                            }
                            <Fragment>
                                <Grid
                                    container
                                    direction='row'
                                    justify='center'
                                    alignItems='center'
                                >
                                    {
                                        errors != null ?
                                            <Grid item xs={8} sm={5} md={3} lg={3} xl={3}><Button className={classes.button} variant='contained' color='primary' href='/'> Back to Home Page</Button></Grid> :
                                            <Grid container justify="center">
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Typography align='center' className={classes.paragraph}>For us to verify if it's you, we will be requiring a One-Time Password (OTP).</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <Button style={{ textAlign: 'right' }} className={classes.button} variant='contained' color='primary' type='submit' onClick={handleSubmitClick}>Send OTP</Button>
                                                </Grid>
                                            </Grid>
                                    }

                                </Grid>
                            </Fragment>
                        </Paper>
                        <Dialog aria-labelledby='customized-dialog-title' open={open}>
                            <DialogContent dividers>
                                <OTP handleClose={handleClose} />
                            </DialogContent>
                        </Dialog>
                    </Fragment>
            }
        </div>
        </div>
    );
};

export default SchedulerMain;
